import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  PurchaseOrderCancelReasonBean,
  PurchaseOrderCancelReasonSearchCriteria,
  RestPurchaseOrderCancelListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class PurchaseOrderCancelReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();

    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  deleteCancelReason = (e, val, rowData) => {
    if (e.detail === 1) this.props.deleteCancelReason(val, rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  editPurchaseOrderCancelReason = (e, rowdata) => {
    if (e.detail === 1) this.props.editPurchaseOrderCancelReason(rowdata);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  render() {
    let purchaseOrderCancelReason_list =
      this.props.purchaseOrderCancelReason_list;
    let purchaseOrderCancelReasonData =
      this.props.purchaseOrderCancelReasonData;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">
                Purchase Order Cancel Reason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={purchaseOrderCancelReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {purchaseOrderCancelReason_list != null ? (
              <tbody>
                {purchaseOrderCancelReason_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.editPurchaseOrderCancelReason(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>

                    <td> {Info.description}</td>

                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>

                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteCancelReason(e, Info.code)}
                      >
                        {<DeleteIcon />}
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {purchaseOrderCancelReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class PurchaseOrderCancelReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();

    this.state = {
      showHide: this.props.showHide,
      purchaseOrderCancelReasonData: this.props.purchaseOrderCancelReasonData,
    };
  }

  componentDidMount() {
    this.setInputFocus();
  }

  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }

  onChange = (e) => {
    this.props.onChange(e);
  };

  savePurchaseOrderCancelReason = (e) => {
    this.props.savePurchaseOrderCancelReason(
      this.state.purchaseOrderCancelReasonData
    );
  };

  closePurchaseOrderCancelReasonEntryForm() {
    this.props.closePurchaseOrderCancelReasonEntryForm();
  }

  render() {
    let purchaseOrderCancelReasonData =
      this.props.purchaseOrderCancelReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="2">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={purchaseOrderCancelReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="2">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter PurchaseOrderCancelReasonCode"
              onChange={this.onChange}
              value={purchaseOrderCancelReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="2">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={purchaseOrderCancelReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={purchaseOrderCancelReasonData.isActive}
            />
          </Col>
        </Row>

        <br />
      </div>
    );
  }
}

class PurchaseOrderCancelReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrderCancelReason_list: [],
      response: {},
      pageTitle: "Purchase Order Cancel Reason",
      purchaseOrderCancelReasonData: new PurchaseOrderCancelReasonBean(),
      pageList: new PageListBean(),
      criteria: new PurchaseOrderCancelReasonSearchCriteria(),
      companyCode: "",

      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isPurchaseOrderCancelReasonListFormOpen: true,
      isPurchaseOrderCancelReasonEntryFormOpen: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }

  moduleCaption = "Purchase Order Cancel Reason";

  cleardata = () => {
    let purchaseOrderCancelReasonData = new PurchaseOrderCancelReasonBean();
    purchaseOrderCancelReasonData.companyCode = this.companyCode;
    this.setState({
      purchaseOrderCancelReasonData: purchaseOrderCancelReasonData,
    });
  };
  opentypeforms = () => {
    let purchaseOrderCancelReasonData =
      this.state.purchaseOrderCancelReasonData;
    this.editPurchaseOrderCancelReason(purchaseOrderCancelReasonData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  savePurchaseOrderCancelReasonResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closePurchaseOrderCancelReasonEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };
  validatePurchaseOrderCancelReason = (purchaseOrderCancelReasonData) => {
    let isPurchaseOrderCancelReasonData = false;
    let err_list = [];
    let errorMessage = "";
    if (purchaseOrderCancelReasonData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(purchaseOrderCancelReasonData.description)) {
        let errMsg = "PurchaseOrderCancelReason Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(purchaseOrderCancelReasonData.code)) {
        let errMsg = "PurchaseOrderCancelReason Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isPurchaseOrderCancelReasonData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isPurchaseOrderCancelReasonData = true;
      this.setState({ isShowAlert: false });
    }
    return isPurchaseOrderCancelReasonData;
  };
  savePurchaseOrderCancelReason = (purchaseOrderCancelReasonData) => {
    let isValidLine = false;
    isValidLine = this.validatePurchaseOrderCancelReason(
      purchaseOrderCancelReasonData
    );
    if (isValidLine) {
      if (purchaseOrderCancelReasonData.isFetched == true) {
        if (
          SecurityAccessManager.PurchaseOrderCancelReasonMaintenanceEdit_IsAccessible()
        ) {
          MasterService.updatePurchaseOrderCancelReason(
            purchaseOrderCancelReasonData,
            this.savePurchaseOrderCancelReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Edit Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderCancelReasonMaintenanceCreate_IsAccessible()
        ) {
          MasterService.createPurchaseOrderCancelReason(
            purchaseOrderCancelReasonData,
            this.savePurchaseOrderCancelReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Create Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  editPurchaseOrderCancelReasonResponse = (response) => {
    if (response.data != null) {
      if (response.data.purchaseOrderCancelReasonBean != null) {
        let purchaseOrderCancelReasonData =
          response.data.purchaseOrderCancelReasonBean;
        this.setState({
          purchaseOrderCancelReasonData: purchaseOrderCancelReasonData,
        });
        this.disable();
      }
    }
    this.openPurchaseOrderCancelReasonEntryForm();
  };

  editPurchaseOrderCancelReason = (purchaseOrderCancelReasonCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCancelReasonCode;
    if (
      SecurityAccessManager.PurchaseOrderCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readPurchaseOrderCancelReason(
        readrestInput,
        this.editPurchaseOrderCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let temp_purchaseOrderCancelReasondata =
      this.state.purchaseOrderCancelReasonData;
    temp_purchaseOrderCancelReasondata[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderCancelReasonData: temp_purchaseOrderCancelReasondata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let purchaseOrderCancelReasonData =
      this.state.purchaseOrderCancelReasonData;
    purchaseOrderCancelReasonData.companyCode = this.companyCode;
    purchaseOrderCancelReasonData.code =
      this.state.purchaseOrderCancelReasonData.code.toUpperCase();
    this.clearError();
    this.savePurchaseOrderCancelReason(purchaseOrderCancelReasonData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closePurchaseOrderCancelReasonEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openPurchaseOrderCancelReasonEntryForm = () => {
    this.setState({
      isPurchaseOrderCancelReasonListFormOpen: false,
      isPurchaseOrderCancelReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,

      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closePurchaseOrderCancelReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isPurchaseOrderCancelReasonListFormOpen: true,
      isPurchaseOrderCancelReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,

      isShowClearErrorButton: false,
      pageTitle: pageTitle,

      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  deleteCancelReason = (code, rowData) => {
    //
  };
  loadPurchaseOrderCancelReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderCancelReasonPageList != null
    ) {
      let purchaseOrderCancelReasonList = new Array();
      if (
        !isEmptyArray(
          response.data.purchaseOrderCancelReasonPageList
            .purchaseOrderCancelReason
        )
      ) {
        purchaseOrderCancelReasonList =
          response.data.purchaseOrderCancelReasonPageList
            .purchaseOrderCancelReason;
        purchaseOrderCancelReasonList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.purchaseOrderCancelReasonPageList.currentPage;
      pageList.pageSize =
        response.data.purchaseOrderCancelReasonPageList.pageSize;
      pageList.totalCount =
        response.data.purchaseOrderCancelReasonPageList.totalCount;
      this.setState({
        purchaseOrderCancelReason_list: purchaseOrderCancelReasonList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new PurchaseOrderCancelReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPurchaseOrderCancelReasonPage(pageInput, criteria);
  };
  loadPurchaseOrderCancelReasonPage = (pageList, searchCriteria) => {
    let criteria = new PurchaseOrderCancelReasonSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestPurchaseOrderCancelListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.PurchaseOrderCancelReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getPurchaseOrderCancelPageList(
        requestInput,
        this.loadPurchaseOrderCancelReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };

  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.purchaseOrderCancelReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderCancelReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isPurchaseOrderCancelReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isPurchaseOrderCancelReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isPurchaseOrderCancelReasonListFormOpen && (
          <PurchaseOrderCancelReasonListForm
            purchaseOrderCancelReason_list={
              this.state.purchaseOrderCancelReason_list
            }
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            purchaseOrderCancelReasonData={
              this.state.purchaseOrderCancelReasonData
            }
            editPurchaseOrderCancelReason={this.editPurchaseOrderCancelReason}
            editPurchaseOrderCancelReasonSearch={
              this.editPurchaseOrderCancelReasonSearch
            }
            deleteCancelReason={this.deleteCancelReason}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {!this.state.isPurchaseOrderCancelReasonListFormOpen && (
          <PurchaseOrderCancelReasonEntryForm
            purchaseOrderCancelReasonData={
              this.state.purchaseOrderCancelReasonData
            }
            closePurchaseOrderCancelReasonEntryForm={
              this.closePurchaseOrderCancelReasonEntryForm
            }
            savePurchaseOrderCancelReason={this.savePurchaseOrderCancelReason}
            editPurchaseOrderCancelReason={this.editPurchaseOrderCancelReason}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}

function PurchaseOrderCancelReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <PurchaseOrderCancelReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default PurchaseOrderCancelReasonAttributeModule;
